<template>
    <modal name="first-login-4" @before-open="beforeOpen" @before-close="beforeClose"
        :classes="['v--modal', 'error-modal', 'first-login', 'first-login-4', hasBugs && 'has-bugs']" :width="400"
        :height="'auto'" :scrollable="true" :adaptive="true">
        <div class="modal-title">{{ $t("firstLogin.downloadPuzzle") }}</div>
        <div class="modal-body">
            <img v-if="puzzle" :src="puzzle" alt="" class="first-login-puzzle">
            <div class="modal-subtitle">{{ $t("firstLogin.uploadYourImage") }}</div>
            <input type="file" accept="image/*" id="image" name="image" v-validate.persist="{
                required: false,
                size: 10000,
                ext: ['jpeg', 'jpg', 'png'],
                mindimensions: [600, 600]
            }" data-vv-as="file" @change="addImage($event, 'image', false, checkErrors)" class="input-hidden">
            <label for="image" class="button-blue">{{ $t("firstLogin.uploadImage") }}</label>


            <div class="form-bottom form-bottom-4 buttons-center">

                <button @click="next(false)" v-if="!loader" :disabled="!puzzle" class="button">{{ $t("firstLogin.complete")
                }}</button>
                <button v-if="loader" type="button" class="button button-loader"></button>
                <br>
                <span @click="next(true)" class="link">{{ $t("firstLogin.skipStep") }}</span>
            </div>
        </div>
    </modal>
</template>

<script>
import { mapGetters } from 'vuex';
import { uploadImage } from '@/mixins/uploadImage';
import { localizeValidation } from '@/mixins/localizeValidation';
import { observeListEnd } from '@/mixins/observeListEnd';
import { checkScroll } from '@/mixins/checkScroll';
import { saveProfile } from '@/mixins/saveProfile';

export default {
    name: 'UploadPhotos',
    props: {
        i18n: Object,
    },
    mixins: [
        uploadImage,
        localizeValidation,
        observeListEnd,
        checkScroll,
        saveProfile
    ],
    data() {
        return {
            hasBugs: false,
            loader: false,
            image: null,
            puzzle: null,
            avatar: null,
            tempUser: {}
        }
    },
    computed: {
        ...mapGetters({
            user: 'user/fetchUser',
            photosErrors: 'photos/errors'
        }),
        localUser: function () {
            if (Object.keys(this.tempUser).length) {
                return this.tempUser;
            }
            this.tempUser = Object.assign({}, this.user);
            return this.tempUser;
        }
    },
    watch: {
        newAlbum() {
            this.setNewAlbum();
        }
    },
    methods: {
        beforeOpen(event) {
            this.checkScroll();
            this.localizeValidation();
            this.tempUser = event.params.localUser;
            let self = this;
            const minDimensionsRule = {
                getMessage(field, [width, height], data) {
                    return (data && data.message) || `Изображение должно быть не менее чем ${width}*${height} пикселей`;
                },
                validate(files, [width, height]) {
                    const validateImage = (file, width, height) => {
                        const URL = window.URL || window.webkitURL;
                        return new Promise(resolve => {
                            const image = new Image();
                            image.onerror = () => resolve({ valid: false });
                            image.onload = () => resolve({
                                valid: image.width >= Number(width) && image.height >= Number(height)
                            });

                            image.src = URL.createObjectURL(file);
                        });
                    };
                    const list = [];
                    for (let i = 0; i < files.length; i++) {
                        if (! /\.(jpg|svg|jpeg|png|bmp|gif)$/i.test(files[i].name)) {
                            return false;
                        }
                        list.push(files[i]);
                    }
                    return Promise.all(list.map(file => validateImage(file, width, height)));

                }
            };

            this.$validator.extend('mindimensions', minDimensionsRule);

            const isPuzzleRule = {
                getMessage(field, [album, width, height], data) {
                    return (data && data.message) || `Для создания пазла изображение должно быть не менее чем ${width}*${height} пикселей`;
                },
                validate(value, [album, width, height]) {
                    if (self.puzzle) {

                        return new Promise(resolve => {
                            const image = new Image();
                            image.onerror = () => resolve({ valid: false });
                            image.onload = () => resolve({
                                valid: image.width >= Number(width) && image.height >= Number(height)
                            });

                            image.src = file.image;
                        });
                    } else {
                        return { valid: true };
                    }

                }
            }

            this.$validator.extend('isPuzzle', isPuzzleRule);
        },
        beforeClose() {
            this.checkRemoveScroll();
        },
        checkErrors() {
            let self = this;
            setTimeout(function () {
                self.$validator.validateAll()
                    .then((valid) => {
                        if (valid) {
                            if (
                                self.image
                            ) {
                                self.$modal.show(
                                    'crop-puzzle',
                                    {
                                        image: self.image,
                                        create: true,
                                        callback: self.create
                                    }
                                );
                                self.resetPhotos();

                            }
                        } else {
                            self.$modal.show('dialog', {
                                title: 'Предупреждение!',
                                text: self.errors.first(self.errors.items[0].field),
                                buttons: [
                                    {
                                        title: 'ОК',
                                        handler: () => {
                                            if (self.errors.has('image')) {
                                                self.errors.clear();
                                                self.$validator.reset();
                                                if (
                                                    document.getElementById('image') &&
                                                    document.getElementById('image').length
                                                ) {
                                                    document.getElementById('image').value = '';
                                                }
                                                self.image = null;
                                            }
                                            self.$modal.hide('dialog');
                                        }
                                    }
                                ]
                            });
                        }
                    });
            }, 300);
        },
        resetPhotos() {
            this.errors.clear();
            this.$validator.reset();
            if (
                document.getElementById('image') &&
                document.getElementById('image').length
            ) {
                document.getElementById('image').value = '';
            }

            this.image = null;
        },
        create(puzzle) {
            this.$modal.hide('crop-puzzle');
            this.puzzle = puzzle;
        },
        next(skip = false) {

            this.loader = true;

            this.avatar = this.localUser.avatar;
            delete this.tempUser.avatar;
            this.save(() => {
                this.onSent(skip);
            }, true, this.onSentError);
        },
        onSent(skip = false) {
            let promises = [];
            if (this.puzzle && !skip) promises.push(this.$store.dispatch('myPuzzles/create', [{ image: this.puzzle }]));
            if (this.avatar) promises.push(this.$store.dispatch('user/setAvatar', { avatar: this.avatar }));
            Promise.all(promises)
                .then(() => {
                    this.loader = false;
                    this.$modal.hide('first-login-4');
                    this.$modal.show('dialog', {
                        title: this.$t("myFriends.success"),
                        text: this.$t("profileEdit.changesRetained"),
                        buttons: [
                            {
                                title: this.$t("roulette.ok")
                            }
                        ]
                    });
                })
                .catch((err) => {

                    this.loader = false;
                });
        }
    }
}
</script>

<style lang="scss">
@import '~@/assets/styles/components/_validation';
@import '~@/assets/styles/layout/_upload-photos';
</style>
